import { render } from "./ClassDiagram.vue?vue&type=template&id=57d036bc&scoped=true"
import script from "./ClassDiagram.vue?vue&type=script&lang=js"
export * from "./ClassDiagram.vue?vue&type=script&lang=js"

import "./ClassDiagram.vue?vue&type=style&index=0&id=57d036bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d036bc"]])

export default __exports__